/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsRefreshAodRunRunActionsMutationResponse, AuditReportsRefreshAodRunRunActionsPathParams, AuditReportsRefreshAodRunRunActions400, AuditReportsRefreshAodRunRunActions401, AuditReportsRefreshAodRunRunActions403, AuditReportsRefreshAodRunRunActions404 } from "../models/AuditReportsRefreshAodRunRunActions";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { auditReportsRefreshAodRunRunActions } from "../axios/auditReportsRefreshAodRunRunActions";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const auditReportsRefreshAodRunRunActionsMutationKey = () => [{ url: '/audit-reports/v1/aod-runs/:id/refresh' }] as const

export type AuditReportsRefreshAodRunRunActionsMutationKey = ReturnType<typeof auditReportsRefreshAodRunRunActionsMutationKey>

export function auditReportsRefreshAodRunRunActionsMutationOptions<TContext = unknown>(config: Partial<RequestConfig> & { client?: Client } = {}) {

        const mutationKey = auditReportsRefreshAodRunRunActionsMutationKey()
        return mutationOptions<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, {id: AuditReportsRefreshAodRunRunActionsPathParams["id"]}, TContext>({
          mutationKey,
          mutationFn: async({ id }) => {
            return auditReportsRefreshAodRunRunActions(id, config)
          },
        })

}

/**
 * @description Re-executes the AOD run job for runs with COMPLETED_WITHOUT_EXPORT status
 * @summary Refresh a run
 * {@link /audit-reports/v1/aod-runs/:id/refresh}
 */
export function useAuditReportsRefreshAodRunRunActions<TContext>(options: 
{
  mutation?: UseMutationOptions<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, {id: AuditReportsRefreshAodRunRunActionsPathParams["id"]}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? auditReportsRefreshAodRunRunActionsMutationKey()

          const baseOptions = auditReportsRefreshAodRunRunActionsMutationOptions(config) as UseMutationOptions<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, {id: AuditReportsRefreshAodRunRunActionsPathParams["id"]}, TContext>
          

          return useMutation<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, {id: AuditReportsRefreshAodRunRunActionsPathParams["id"]}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<AuditReportsRefreshAodRunRunActionsMutationResponse, ResponseErrorConfig<AuditReportsRefreshAodRunRunActions400 | AuditReportsRefreshAodRunRunActions401 | AuditReportsRefreshAodRunRunActions403 | AuditReportsRefreshAodRunRunActions404>, {id: AuditReportsRefreshAodRunRunActionsPathParams["id"]}, TContext>
      
}